import React from 'react';

import { Input as AntInput, type InputProps, InputRef } from 'antd-v5';
import type { SearchProps } from 'antd-v5/lib/input';
import type { PasswordProps } from 'antd-v5/lib/input/Password';
import cn from 'classnames';

import styles from '../scss/_input.scss';

interface ComponentProps extends InputProps {
  className?: string;
}

const AntSearch = AntInput.Search;

export const TextArea = AntInput.TextArea;

export const Input: React.FC<ComponentProps> = React.forwardRef<
  InputRef,
  ComponentProps
>(function Input({ className, ...rest }, ref) {
  return (
    <div
      className={cn(styles.container, {
        [styles.withPrefix]: !!rest.prefix,
        [styles.withAddonBefore]: !!rest.addonBefore,
        [styles.withSuffix]: !!rest.suffix,
      })}
    >
      <AntInput
        id={rest.id}
        prefixCls="prefix-cls"
        className={cn(className, {
          [styles.input]: true,
        })}
        ref={ref}
        {...rest}
      />
      <label htmlFor={rest.id} className={styles.floatingLabel}>
        {rest.placeholder}
      </label>
    </div>
  );
});

export const Search: React.FC<SearchProps> = props => (
  <AntSearch variant="borderless" enterButton {...props} />
);

const AntPassword = AntInput.Password;

export const Password = React.forwardRef<InputRef, PasswordProps>(
  function Password(props, ref) {
    return (
      <div>
        <AntPassword {...props} ref={ref} />
      </div>
    );
  },
);

export default Input;
